import http from './httpClient'
import { bffURL } from '../config'

export default class Applications {
  static getApplicationsWithToken (token, idToken) {
    return http.get(
      `${bffURL}/profiles/token/${token}/applications/active`, idToken
    )
  }

  static getApplicationWithToken (token, idToken) {
    return http.get(
      `${bffURL}/applications/${token}`, idToken
    )
  }

  static getApplicationsWithProfileId (idToken) {
    return http.get(
      `${bffURL}/auth/profiles/applications/active`, idToken
    )
  }

  static async requestApplicationRecovery (contact, contactType, idToken) {
    const recoveryInformation = {}
    if (contactType === 'email') {
      recoveryInformation.email = contact
    } else if (contactType === 'phone') {
      recoveryInformation.phone = contact
    }
    return await http.post(
      `${bffURL}/profiles/applicants/send-recovery-notification`,
      recoveryInformation,
      { headers: { Authorization: `Bearer ${idToken}` } }
    )
  }

  static getMagicJwtFromToken (token) {
    return http.getWithRetryOn404(
      `${bffURL}/token/${token}/jwt`
    )
  }
}
